import { observer } from "mobx-react";
import {
  Box,
  Typography,
  Card,
  List,
  ListItem,
  ListItemButton,
  Collapse,
} from "@mui/material";
import { useState } from "react";
import { useStoreContext } from "..";

const Help = observer(() => {
  const [isUpper, setIsUpper] = useState<boolean>(true);
  const { userStore } = useStoreContext();
  return (
    <Box
      className="page-container"
      sx={{ marginBottom: userStore.isIphoneUser ? 8 : 0 }}
    >
      <Card
        style={{
          borderRadius: 8,
        }}
      >
        <List disablePadding dense>
          <ListItem
            disablePadding
            sx={{ height: 40, borderBottom: "1px solid lightgrey" }}
            onClick={() => {
              if (!isUpper) {
                setIsUpper(true);
              }
            }}
          >
            <ListItemButton sx={{ height: "100%" }}>
              <h4>Gör Hälsodagboken till en app på din mobil</h4>
            </ListItemButton>
          </ListItem>
          <Collapse in={isUpper} unmountOnExit sx={{ padding: 4 }}>
            <h4>Android</h4>
            <Box sx={{ padding: 2 }}>
              <Typography>
                Öppna din webbläsäre. Skriv in adressen till Hälsodagboken
              </Typography>
              <Typography>
                Spara sidan som bokmärke. Det är lite olika hur man gör i olika
                telefoner. På vissa finns en stjärnä uppe till höger bredvid
                adressraden. I andra måste man trycka på den fasta menyknappen
                och "välja lägg till bokmärke".
              </Typography>
              <Typography>
                Nu ligger Hälsodagboken bland dina bokmärken. Gå in och titta på
                dina bokmärken, leta upp Hälsodagboken, tryck och håll kvar
                fingret på bokmärket tills en ny meny dyker upp. Välj "lägg till
                genväg på startsida/hemsida"
              </Typography>
              <Typography sx={{ marginBottom: 2 }}>
                Nu har du en genväg direkt till Hälsodagboken på din hemskärm
              </Typography>
            </Box>
            <h4>Iphone</h4>
            <Box sx={{ padding: 2 }}>
              <Typography>
                Öppna Safari. Skriv in adressen till Hälsodagboken.
              </Typography>
              <Typography>
                Tryck på den lilla rutan med en pil i, längst ner i mitten på
                skärmen. Välj "Lägg till på hemskärmen"
              </Typography>

              <Typography>
                Nu har du en genväg direkt till Hälsodagboken på din hemskärm
              </Typography>
            </Box>
          </Collapse>
          <ListItem
            disablePadding
            sx={{ height: 40, borderBottom: "1px solid lightgrey" }}
            onClick={() => {
              if (isUpper) {
                setIsUpper(false);
              }
            }}
          >
            <ListItemButton sx={{ height: "100%" }}>
              <h4>Kontakt</h4>
            </ListItemButton>
          </ListItem>
          <Collapse in={!isUpper} unmountOnExit sx={{ padding: 4 }}>
            <Typography>
              Kontakta din immunbristmottagning om du har frågor om hur du
              använder och registrerar i Hälsodagboken PIDcare.
            </Typography>
          </Collapse>
        </List>
      </Card>
    </Box>
  );
});

export default Help;
